if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      static cachedHTML = '';

      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        const productId = this.dataset.productId;

        // Synchronously restore cached HTML if section re-render produced an empty element
        if ((!this.innerHTML || this.innerHTML.trim().length === 0) && CartUpsell.cachedHTML) {
          this.innerHTML = CartUpsell.cachedHTML;
          this.classList.remove('hidden');
          this.initSwiper();
        }

        if (productId && this.dataset.url) {
          this.loadRecommendations(productId);
        } else if (this.innerHTML.trim().length > 0) {
          this.initSwiper();
        }

        this.addEventListener('click', this.onClick.bind(this));
      }

      loadRecommendations(productId) {
        const url = `${this.dataset.url}&product_id=${productId}`;
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const recommendationsEl = html.querySelector('cart-upsell');
            if (recommendationsEl && recommendationsEl.innerHTML.trim().length > 0) {
              CartUpsell.cachedHTML = recommendationsEl.innerHTML;
              this.innerHTML = recommendationsEl.innerHTML;
              this.classList.remove('hidden');
              this.initSwiper();
            } else {
              if (!this.innerHTML || this.innerHTML.trim().length === 0) {
                this.classList.add('hidden');
              }
            }
          })
          .catch((e) => {
            console.error('Error fetching cart upsell recommendations:', e);
          });
      }

      initSwiper() {
        const swiperEl = this.querySelector('.cart-upsell__swiper');
        if (!swiperEl) return;

        const runInit = () => {
          if (this.swiper) {
            try {
              this.swiper.destroy(true, true);
            } catch (err) {}
            this.swiper = null;
          }

          if (typeof Swiper !== 'undefined') {
            this.swiper = new Swiper(swiperEl, {
              slidesPerView: 1.1,
              spaceBetween: 10,
              grabCursor: true,
              navigation: {
                nextEl: this.querySelector('.cart-upsell__nav-next'),
                prevEl: this.querySelector('.cart-upsell__nav-prev'),
              },
              pagination: {
                el: this.querySelector('.cart-upsell__pagination'),
                clickable: true,
                dynamicBullets: true,
              },
              breakpoints: {
                480: {
                  slidesPerView: 1.2,
                  spaceBetween: 12,
                },
              },
            });
          }
        };

        if (typeof Swiper === 'undefined') {
          let attempts = 0;
          const interval = setInterval(() => {
            attempts++;
            if (typeof Swiper !== 'undefined') {
              clearInterval(interval);
              runInit();
            } else if (attempts > 30) {
              clearInterval(interval);
            }
          }, 100);
        } else {
          runInit();
        }
      }

      onClick(event) {
        const button = event.target.closest('.cart-upsell__add-btn');
        if (!button || button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        event.preventDefault();
        this.addVariantToCart(variantId, button);
      }

      addVariantToCart(variantId, button) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cartDrawer = document.querySelector('cart-drawer');
        const sectionsToRender = cartDrawer
          ? cartDrawer.getSectionsToRender().map((section) => section.id)
          : ['cart-drawer', 'cart-icon-bubble'];

        const body = JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: body,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-upsell',
                productVariantId: variantId,
                cartData: response,
              });
            }

            if (cartDrawer && response.sections) {
              cartDrawer.renderContents(response);
            }
          })
          .catch((error) => {
            console.error('Error adding upsell product to cart:', error);
          })
          .finally(() => {
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
